// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/base.css'
import $ from 'jquery'

import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'

import global_ from '@/api.js'
Vue.prototype.GLOBAL = global_

Vue.config.productionTip = false
Vue.use(ElementUI)//全局使用ElementUI
Vue.prototype.$http=axios
Vue.use(VueAxios,axios)
Vue.use(Vuex)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

//不管跳转到那个页面始终回到另一个页面的顶部
//router.afterEach((to,from,next) => {
//
//  window.scrollTo(0,0);
//
//})



// WEBPACK FOOTER //
// ./src/main.js